import { useQuery } from '@tanstack/react-query';
import { awaitJSON, ToolsLambdaFetch } from '@src/utils/fetch-utils';
import { overrideDateLinear } from '@src/utils/test-account-utils';
import { SpikeChartData } from './spike-chart-constants';
import { buildSpikeChartData, getSpikeChartData } from './spike-chart-utils';

export const useSpikeChartData = (
  company: string,
  week: string,
  kpi: string | undefined,
  isTestCompany: boolean
): ReturnType<typeof useQuery<SpikeChartData[]>> =>
  useQuery({
    meta: { suppressGlobalError: true },
    queryKey: ['spikeChartData', company, week, kpi],
    enabled: Boolean(kpi) && Boolean(company),
    queryFn: async (): Promise<SpikeChartData[]> => {
      const dateToUse = overrideDateLinear(company, week);
      const spikeData = await getSpikeChartData(kpi as string, dateToUse);
      if (!spikeData) {
        throw new Error('No data available for this week, please select another');
      }
      return buildSpikeChartData(spikeData, isTestCompany);
    }
  });

export const useSpotAttributionExists = (
  kpi: string | undefined
): ReturnType<typeof useQuery<boolean>> =>
  useQuery({
    queryKey: ['spotAttributionExists', kpi],
    enabled: Boolean(kpi),
    queryFn: async (): Promise<boolean> => {
      const res = await ToolsLambdaFetch('/s3_exists', {
        params: { bucket: 'bpm-ml-data', key: `v4/${kpi}/latest/spot_attribution.csv.gz` }
      });
      const existObj = await awaitJSON<{ exists: boolean }>(res);
      return existObj.exists;
    }
  });
